import React, { useState, useMemo } from 'react';
import './AzureAzulejos.css';
import VegIcon from '../../../components/VegIcon';
import { paginateMenu } from '../../../utils/menuPagination';

const AzureAzulejos = ({ data, isSingleMenu }) => {
    const restaurant = data?.restaurant || {};
    const rawMenus = data?.menus || [];

    const [activeMenuIndex, setActiveMenuIndex] = useState(0);

    const visiblePages = useMemo(() => {
        if (isSingleMenu) {
            return rawMenus.flatMap(menu => paginateMenu(menu));
        }
        const activeMenu = rawMenus[activeMenuIndex];
        return activeMenu ? paginateMenu(activeMenu) : [];
    }, [isSingleMenu, rawMenus, activeMenuIndex]);

    const handleNext = () => {
        if (activeMenuIndex < rawMenus.length - 1) {
            setActiveMenuIndex(p => p + 1);
            window.scrollTo(0, 0);
        }
    };

    const handlePrev = () => {
        if (activeMenuIndex > 0) {
            setActiveMenuIndex(p => p - 1);
            window.scrollTo(0, 0);
        }
    };

    if (!data) return <div className="loading">Loading...</div>;

    return (
        <div className="aa-root">
            {!isSingleMenu && (
                <div className="tmpl-nav-container no-print" style={{ justifyContent: 'center' }}>
                    <div className="tmpl-nav-controls">
                        <button className="tmpl-nav-btn" onClick={handlePrev} disabled={activeMenuIndex === 0}>
                            ← Prev Menu
                        </button>
                        <div className="tmpl-page-indicator">
                            {rawMenus[activeMenuIndex]?.name || `Menu ${activeMenuIndex + 1}`}
                            <span style={{ fontSize: '0.8em', opacity: 0.7, marginLeft: '8px' }}>
                                ({activeMenuIndex + 1}/{rawMenus.length})
                            </span>
                        </div>
                        <button className="tmpl-nav-btn" onClick={handleNext} disabled={activeMenuIndex === rawMenus.length - 1}>
                            Next Menu →
                        </button>
                    </div>
                </div>
            )}

            <div className="aa-menu-container">
                {visiblePages.map((page, index) => {
                    const categories = (page.categories || []);
                    const showHeader = isSingleMenu ? (index === 0) : (page.chunkIndex === 0);
                    const showMenuTitle = page.chunkIndex === 0;

                    return (
                        <article key={`${page.id || page.name}-${index}`} className="pt-page active">
                            {/* Decorative Tile Corners */}
                            <div className="aa-tile aa-tile-tl"></div>
                            <div className="aa-tile aa-tile-tr"></div>
                            <div className="aa-tile aa-tile-bl"></div>
                            <div className="aa-tile aa-tile-br"></div>

                            {showHeader && (
                                <header className="aa-header">
                                    <div className="aa-crest-box">
                                        <div className="aa-crest">
                                            {restaurant.establishedYear && <span className="aa-crest-inner">Est. {restaurant.establishedYear}</span>}
                                        </div>
                                    </div>
                                    <h1 className="aa-name">{restaurant.name}</h1>
                                    {restaurant.tagline && <p className="aa-sub">{restaurant.tagline}</p>}
                                </header>
                            )}

                            <main className="aa-menu">
                                {showMenuTitle && (
                                    <h2 className="aa-menu-title">{page.name}</h2>
                                )}
                                <div className="aa-cat-grid">
                                    {categories.map(category => (
                                        <section key={category.id} className="aa-category">
                                            <h3 className="aa-category-title">{category.name}</h3>
                                            <div className="aa-items">
                                                {(category.items || []).map(item => (
                                                    <div key={item.id} className="aa-item">
                                                        <div className="aa-item-top">
                                                            <div className="aa-item-name-group">
                                                                {(item.isVeg !== undefined && item.isVeg !== null) && (
                                                                    <span className={`aa-veg-badge ${item.isVeg ? 'veg' : 'nonveg'}`}>
                                                                        <span className="aa-veg-mark"></span>
                                                                    </span>
                                                                )}
                                                                <span className="aa-item-name">{item.name}</span>
                                                            </div>
                                                            <span className="aa-item-price">₹{item.price}</span>
                                                        </div>
                                                        {item.description && <p className="aa-item-desc">{item.description}</p>}
                                                    </div>
                                                ))}
                                            </div>
                                        </section>
                                    ))}
                                </div>
                            </main>

                            <footer className="aa-footer">
                                <div className="aa-contact-details">
                                    {restaurant.address && <span>{restaurant.address}</span>}
                                    {restaurant.phoneNumber && <span> | {restaurant.phoneNumber}</span>}
                                </div>
                                <div className="aa-pattern-bar"></div>
                            </footer>
                        </article>
                    );
                })}
            </div>
        </div>
    );
};

export default AzureAzulejos;
